<template>
	<v-tooltip top>
		<button
			class="tw-px-1"
			slot="activator"
			:color="color"
			:disabled="disabled"
			@click.prevent="clickIcon"
		>
			<template v-if="icon">
				<v-icon :color="color" :size="size" :style="isListAll">{{ icon }}</v-icon>
			</template>
			<template v-else>
				<img :src="img" alt="text" :height="size">
			</template>
		</button>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>

function clickIcon($e) {
	this.$emit('click-icon', $e);
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

export default {
	name: 'app-btn',
	computed: {
		isListAll,
	},
	props: {
		color: {
			type: String,
			default: 'success',
		},
		icon: String,
		img: String,
		size: [Number, String],
		text: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		clickIcon,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/app-btn.vue